export function getParameterByName(name: string, url = window.location.href) {
  name = name.replace(/[[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  let value = results[2];
  if (name !== "q") {
    // only replace '+' with space for non-base64 parameters
    // base64 may contain '+' as part of the encoded string
    value = value.replace(/\+/g, " ");
  }
  return decodeURIComponent(value);
}
